exports.components = {
  "component---src-pages-dataviz-jsx": () => import("./../../../src/pages/dataviz.jsx" /* webpackChunkName: "component---src-pages-dataviz-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

